import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  customerImportCompleteNotificationTitle: {
    description: 'customerImport.customerImportCompleteNotificationTitle',
    defaultMessage: 'Customer Import Complete!',
    id: 'QPVDgU',
  },
  customerImportCompleteNotificationBody: {
    description: 'customerImport.customerImportCompleteNotificationBody',
    defaultMessage: 'Your customer import has completed!',
    id: 'z/UwsS',
  },
  customerImportCompleteStoreRefresh: {
    description: 'customerImport.customerImportCompleteStoreRefresh',
    defaultMessage: 'Click here to view the results.',
    id: 'rDOy6W',
  },
  customerImportLogFailureNotificationTitle: {
    description: 'customerImport.customerImportLogFailureNotificationTitle',
    defaultMessage: 'Customer Import Failure!',
    id: 'dEwOaV',
  },
  customerImportFailureNotificationBody: {
    description: 'customerImport.customerImportFailureNotificationBody',
    defaultMessage: 'Your customer import was not successful. Please try again.',
    id: 'lUz3je',
  },
});
